import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "file-upload" }
const _hoisted_2 = { class: "dashboard-wrapper" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "filename-wrapper" }
const _hoisted_5 = { class: "col name" }
const _hoisted_6 = { class: "opal-Dashboard-Item-fileInfoAndButtons" }
const _hoisted_7 = { class: "opal-Dashboard-Item-fileInfo" }
const _hoisted_8 = { class: "opal-Dashboard-Item-fileName" }
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "opal-Dashboard-Item-status" }
const _hoisted_11 = { class: "opal-Dashboard-Item-statusSize" }

import { ref, computed, reactive, watch } from "vue";
import { useStore } from "vuex";
import useFormatter from "@/use/formatter";
import UppyUploaderWrapper from "@/components/shared/UppyUploaderWrapper.vue";
import { DocumentEntityTypes } from "@/models/enums";


export default /*@__PURE__*/_defineComponent({
  __name: 'GenericUppyUploader',
  props: {
  name: { type: String },
  applicationId: { type: Number },
  documentTypeId: { type: Number, default: 23 },
  applicant: { type: Object },
  height: { type: Number, default: 400 },
  uploadSuccess: { type: Boolean, required: false },
  uploadComplete: { type: Boolean, required: false },
},
  emits: [
  "getDocuments",
  "uploadSuccess",
  "errorMessageUpdated",
  "cancel",
  "resetForm",
],
  setup(__props, { emit: __emit }) {

const props = __props;

const { formatBytes } = useFormatter();

const emit = __emit;
const store = useStore();
let uploadedFiles = reactive([] as any[]);
const fileUploadComplete = ref<boolean>(false);
const uppyId = computed<string>(() => `uppy_${props?.name}`);
const progressBarId = computed<string>(() => `uppy_${props?.name}_progressBar`);
const statusBarId = computed<string>(() => `uppy_${props?.name}_statusBar`);
const successfulUploads = computed(() => store.getters["genericFileUploaderModule/uploadedFiles"]);
const fileName = computed(() =>
  successfulUploads.value?.length > 0
    ? successfulUploads.value[successfulUploads.value?.length - 1].name
    : undefined,
);
const fileSize = computed(() =>
  successfulUploads.value?.length > 0
    ? successfulUploads.value[successfulUploads.value?.length - 1]?.size
      ? `${formatBytes(successfulUploads.value[successfulUploads.value?.length - 1]?.size)}`
      : successfulUploads.value[successfulUploads.value?.length - 1]?.size
    : undefined,
);
const oidcUser = computed(() => store.getters["oidcStore/oidcUser"]);
const contactUs = computed(() => store.getters["contactUs"]);
const errorMessageText = ref<string>("");
const documentTypeId = computed(() => props.documentTypeId);
const metadata = reactive({
  entityId: props?.applicationId,
  personId: props?.applicant?.id,
  entityTypeId: DocumentEntityTypes.Application,
  userId: oidcUser?.value?.sub,
  documentTypeId: props?.documentTypeId || 23,
  applicantVisibility: true,
});

function setErrorMessage(event: any) {
  errorMessageText.value = event.errorMessage;
}

function resetUploadedFiles() {
  store.dispatch("genericFileUploaderModule/setUploadedFiles", []);
}

function handleUploadComplete(event: any) {
  store.dispatch("genericFileUploaderModule/setUploadedFiles", event.successful);

  fileUploadComplete.value = true;

  const file = event?.successful[0];
  if (file) {
    emit("uploadSuccess", { result: true });
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createBlock(UppyUploaderWrapper, {
    uppyId: uppyId.value,
    metadata: metadata,
    height: __props.height,
    "document-type-id": documentTypeId.value,
    "upload-success": __props.uploadSuccess,
    "upload-complete": __props.uploadComplete,
    "contact-us": contactUs.value,
    onErrorMessageUpdate: setErrorMessage,
    onUploadComplete: handleUploadComplete,
    onFileAdded: resetUploadedFiles
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "drag-drop-area",
            id: uppyId.value
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(successfulUploads.value, (file, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: index
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    class: "icon complete",
                    icon: ['fas', 'circle-check']
                  }),
                  _createTextVNode(" " + _toDisplayString(file?.name), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["opal-StatusBar is-waiting", successfulUploads.value.length > 0 ? 'is-complete' : ''])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["opal-StatusBar-progress", successfulUploads.value.length > 0 ? 'is-complete' : '']),
            role: "progressbar",
            "aria-label": "100%",
            "aria-valuetext": "100%",
            "aria-valuemin": "0",
            "aria-valuemax": "100",
            style: {"width":"100%"}
          }, null, 2),
          _cache[0] || (_cache[0] = _createElementVNode("div", {
            class: "opal-StatusBar-content",
            title: "Upload Successful"
          }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "opal-StatusBar-actions" }, null, -1)),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", {
                  class: "opal-Dashboard-Item-name",
                  title: fileName.value
                }, _toDisplayString(fileName.value), 9, _hoisted_9),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(fileSize.value), 1)
                ])
              ])
            ])
          ], 512), [
            [_vShow, successfulUploads.value?.length > 0]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "opal-Dashboard-Item-actionWrapper" }, null, -1))
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["uppyId", "metadata", "height", "document-type-id", "upload-success", "upload-complete", "contact-us"]))
}
}

})